// Bootstrap declarations
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

// Bringing up the additional content to add to the app modal
import AboutModalCommonNote from "../../components/shared/AboutModalCommonNote"

// Context modules
import { useSharedNavigationFunctions } from "../../shared/NavigationFunctions";

// Demo assets
import headerLogo from "./assets/squeakersnft_logo.gif"

const Header = (props) => {

    // Retrieve items from context --------------------------------------------------
    // Navigation functions
    const { 
        handleModalShow, handleModalClose,
        modalShow,
    } = useSharedNavigationFunctions();
    // Retrieve items from context --------------------------------------------------

    return (

    <>

        <header className="container-fluid header">
            
            {/* Storefront row */}
            {/* <Row className="d-flex justify-content-center">
                <img className="d-none d-md-block" src={wonderPalsFrontBanner} 
                    alt="Wonderpals Front Banner" 
                    height={200}
                    />
            </Row> */}
            <div className="d-md-flex justify-content-between align-items-center mt-2 mb-2 mx-5">
                
                <div className="ml-2">
                    <a href="/#" onClick={() => window.open('https://www.lfg-wagmi.xyz/')}>
                        <img src={headerLogo} height={80} alt="Demo Collection Logo" />
                    </a>    
                </div>

                <div className="m-2 headerLogo">
                    Demo Collection
                </div> 

                <div className="mr-2">
                    <a href="/#" onClick={handleModalShow}>About</a>
                </div>

            </div>
 
        </header>

        {/* ABOUT PAGE MODAL  */}
        <Modal className="aboutModal" show={modalShow} onHide={handleModalClose}>
            <Modal.Header>
            <Modal.Title>About this app</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="text-center">
                    <p>Welcome to a demo of the <strong>Collection Explorer tool</strong> (part of the NFT Creator Suite by @ToudeMoune). This app is here to showcase the tool and let you test some of its features.</p> 
                    
                    <p>For more information, please check our <a href="https://www.lfg-wagmi.xyz/" target="_blank">product page</a>.</p>
                    
                    {/* <p><strong>Don't own a Whisker?</strong> No worries, head over to our <a rel="noreferrer" target="_blank" href="https://opensea.io/collection/whiskersnft">Opensea collection</a> to grab one and join the fun.</p>
                    <p><strong>Coded and designed with ❤️ &nbsp;by <a target="_blank" rel="noreferrer" href="https://twitter.com/ToudeMoune">Tchoupi</a></strong>
                    <br/>proud owner of:</p>
                    <p>
                    <a href="https://opensea.io/assets/0x3acce66cd37518a6d77d9ea3039e00b3a2955460/8104" target="_blank" rel="noreferrer"><img className="responsive" height="150" alt="WonderPal #8104" src={tchoupiWP1} /></a>
                    <a href="https://opensea.io/assets/0x3acce66cd37518a6d77d9ea3039e00b3a2955460/8105" target="_blank" rel="noreferrer"><img className="responsive" height="150" alt="WonderPal #8104" src={tchoupiWP2} /></a>
                    </p> */}

                    {/* <AboutModalCommonNote /> */}

                </div>
            </Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={handleModalClose}>
                OK
            </Button>
            </Modal.Footer>
        </Modal>

    </>

    );

}

export default Header;